__webpack_require__.p = "//oss-int.zeehoev.com/codes/cfmoto-i18n-h5/";